import { useEffect } from "react";

const DEFAULT_TITLE = "Air Wave — Live Streaming, Unrestricted";
const DEFAULT_DESC =
  "Air Wave is an ad-free live streaming platform with Multiview, virtual gifting, PK battles, VOD replays, podcasts and a creator-first 95/5 revenue split.";

function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setProp(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Lightweight SEO — sets document title + description without an extra library.
export function useSeo({ title, description } = {}) {
  useEffect(() => {
    const t = title ? `${title} | Air Wave` : DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    document.title = t;
    setMeta("description", d);
    setProp("og:title", t);
    setProp("og:description", d);
    setProp("og:type", "website");
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta("description", DEFAULT_DESC);
    };
  }, [title, description]);
}

// Injects a JSON-LD structured-data <script> and cleans it up on unmount.
// Helps Google understand and trust the page (rich results, AdSense signals).
export function useJsonLd(data, id = "page-jsonld") {
  useEffect(() => {
    if (!data) return;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => { el && el.parentNode && el.parentNode.removeChild(el); };
  }, [data, id]);
}
